export const CURRENCIES = ["USD", "AUD", "GBP"] as const;

export type Currency = typeof CURRENCIES[number];

export type Money = {
  value: string;
  currency: Currency;
};
